import offerConfig from 'offer/config'
import OfferListColumnModel from '../../../modules/offer/components/list/models/offer-list-column-model'
import { sanitizeListColumns } from '../../util/sanitizeListColumns'
import request from '@/modules/base/util/request'

// actions
const FINSIHED_FETCHING_OFFER_LIST_SETTING = 'FINSIHED_FETCHING_OFFER_LIST_SETTING'
const ERROR_FETCHING_OFFER_LIST_SETTING = 'ERROR_FETCHING_OFFER_LIST_SETTING'
const SHOW_LOADER_OFFERS = 'SHOW_LOADER_OFFERS'
const HIDE_LOADER_OFFERS = 'HIDE_LOADER_OFFERS'
const SET_OFFER_LIST_ITEMS = 'SET_OFFER_LIST_ITEMS'
const SET_OFFER_PAGINATION = 'SET_OFFER_PAGINATION'
const SET_OFFERS_FILTER = 'SET_OFFERS_FILTER'
const SET_OFFER_SEARCH_TERM = 'SET_OFFER_SEARCH_TERM'
const REFRESH_OFFERS = 'REFRESH_OFFERS'
const STOP_REFRESHING_OFFERS = 'STOP_REFRESHING_OFFERS'

// reducer
const initialState = {
  isLoading: true,
  error: null,
  items: [],
  setting: {
    columns: [],
  },
  filter: 'all',
  searchTerm: '',
  pagination: {
    offset: 0, // current starting point in list
    count: 0, // count of filtered offers
    totalCount: 0, // count of all offers
    limit: 20, // max offers on page
  },
  shouldRefresh: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FINSIHED_FETCHING_OFFER_LIST_SETTING:
      const { setting } = action
      return Object.assign({}, state, {
        error: null,
        setting,
      })

    case SHOW_LOADER_OFFERS:
      return Object.assign({}, state, {
        isLoading: true,
      })

    case HIDE_LOADER_OFFERS:
      return Object.assign({}, state, {
        isLoading: false,
      })

    case SET_OFFER_LIST_ITEMS:
      const { invoices } = action
      return Object.assign({}, state, {
        items: invoices,
      })

    case SET_OFFER_PAGINATION:
      const { pagination } = action
      const updatedPagination = Object.assign({}, state.pagination, pagination)
      return Object.assign({}, state, { pagination: updatedPagination })

    case SET_OFFERS_FILTER:
      const { filter } = action
      return Object.assign({}, state, {
        filter,
        pagination: initialState.pagination,
      })

    case SET_OFFER_SEARCH_TERM:
      const { searchTerm } = action
      return Object.assign({}, state, {
        searchTerm,
      })

    case REFRESH_OFFERS:
      return Object.assign({}, state, {
        shouldRefresh: true,
      })

    case STOP_REFRESHING_OFFERS:
      return Object.assign({}, state, {
        shouldRefresh: false,
      })

    case ERROR_FETCHING_OFFER_LIST_SETTING:
      const { error } = action
      return Object.assign({}, state, {
        isLoading: false,
        error,
      })

    default:
      return state
  }
}

// action creators
export const showLoader = () => {
  return {
    type: SHOW_LOADER_OFFERS,
  }
}

export const hideLoader = () => {
  return {
    type: HIDE_LOADER_OFFERS,
  }
}

export const setOfferListItems = (invoices) => {
  return {
    type: SET_OFFER_LIST_ITEMS,
    invoices,
  }
}

export const refreshList = () => {
  return {
    type: REFRESH_OFFERS,
  }
}

export const stopRefreshingList = () => {
  return {
    type: STOP_REFRESHING_OFFERS,
  }
}

export const setPagination = (pagination) => {
  return {
    type: SET_OFFER_PAGINATION,
    pagination,
  }
}

export const setSearchTerm = (searchTerm) => {
  return {
    type: SET_OFFER_SEARCH_TERM,
    searchTerm,
  }
}

export const setActiveFilter = (filter) => {
  return {
    type: SET_OFFERS_FILTER,
    filter,
  }
}

const finishedFetchingOfferListSetting = (setting) => {
  return {
    type: FINSIHED_FETCHING_OFFER_LIST_SETTING,
    setting,
  }
}

const errorFetchingOfferListSetting = (error) => {
  return {
    type: ERROR_FETCHING_OFFER_LIST_SETTING,
    error,
  }
}

export const fetchOfferListSetting = () => {
  return (dispatch) => {
    request(offerConfig.offerListSetting, { auth: true, isConcurrent: true })
      .then((response) => {
        const {
          body: {
            data: { columns, isSmallBusiness },
            meta: {
              defaultSort,
              sortBy,
            },
          },
        } = response

        const sanitizedColumns = sanitizeListColumns(columns, defaultSort, sortBy)
        const offerColumns = sanitizedColumns.map((column) => {
          column.displayed = true

          if (column.name === 'totalNet' || column.name === 'totalGross') {
            column.active = !isSmallBusiness
            column.displayed = !isSmallBusiness
          }
          if (column.name === 'total') {
            column.active = isSmallBusiness
            column.displayed = isSmallBusiness
          }

          return new OfferListColumnModel(column)
        })

        dispatch(finishedFetchingOfferListSetting({ columns: offerColumns }))
      })
      .catch((error) => {
        dispatch(errorFetchingOfferListSetting(error))
      })
  }
}
